import React from "react";
import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import "./TreasuryChart.scss";

function TreasuryChart({ color, centerText, chartData }) {
  const data = [
    { name: "DSO", value: chartData },
    { name: "Empty", value: 75 },
  ];

  const COLORS = [color, "#E5E5E5"]; // Green for completion, Grey for empty
  return (
    <div className="treasury-rechart-container">
      {/* Apply a custom CSS class */}
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={32}
            outerRadius={55}
            startAngle={90}
            endAngle={450}
            fill="#8884d8"
            dataKey="value"
            label={() => null} // Disable default label
            labelLine={false}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <text
            className="testingtext"
            x="50%"
            y="50%"
            textAnchor="middle"
            fontSize={15}
            fill="#6B7280"
          >
            <tspan x="50%" dy="-0.3em">
              {`${data[0].value}`}
            </tspan>
            <tspan x="50%" dy="1em">
              {centerText}
            </tspan>
          </text>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default TreasuryChart;
